module.exports = " ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/login/index.html
// module id = 380
// module chunks = 0